import { render, staticRenderFns } from "./StudentIdentificationSection.vue?vue&type=template&id=be4195f6&scoped=true"
import script from "./StudentIdentificationSection.vue?vue&type=script&lang=js"
export * from "./StudentIdentificationSection.vue?vue&type=script&lang=js"
import style0 from "./StudentIdentificationSection.vue?vue&type=style&index=0&id=be4195f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4195f6",
  null
  
)

export default component.exports